import { createSlice } from "@reduxjs/toolkit";

const initialProvidersState = {
  listLoading: false,
  actionsLoading: false,
  mainDashboard: null,
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const dashboardSlice = createSlice({
  name: "providers",
  initialState: initialProvidersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getProductById
    dashboardDataFetched: (state, action) => {
      state.actionsLoading = false;
      state.mainDashboard = action.payload;
      state.error = null;
    },
  },
});
